<template>
  <div class="sidebar">
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu :default-active="$route.path" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose"
        :collapse="isCollapse" :background-color="menuBackgroundColor" :text-color="menuTextColor"
        active-text-color="#ffd04b" router mode="vertical">
        <div class="logo" unique-opened>
          <transition name="sidebarLogoFade">
            <router-link v-if="!isCollapse" key="expand" to="/dashboard">
              <h3 :class="logoClass" :style="{ 'width': sideWidth + 'px' }">{{ systemName }}</h3>
            </router-link>
            <router-link v-else key="collapse" to="/dashboard">
              <h3><el-image style="width: 40px; height: 40px;" :src="logo" alt="logo" fit="cover"></el-image></h3>
            </router-link>
          </transition>
        </div>
        <common-menu-item-aside v-for="(child, index) in menuData" :key="child.path + index" :item="child"
          :isTitle="true"></common-menu-item-aside>
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import logoImg from '@/assets/logo.png'
import { SYSTEM_NAME } from "@/constant/Const";
import CommonMenuItemAside from "./CommonMenuItemAside.vue";
import { mapState } from 'vuex';

export default {
  name: "CommonMenuAside",
  components: {
    CommonMenuItemAside,
  },
  data() {
    return {
      systemName: SYSTEM_NAME,
      logo: logoImg,
      width: "200px",
    };
  },
  methods: {
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },
  },
  computed: {
    noChildren() {
      return this.menuData.filter((item) => !item.children);
    },
    hasChildren() {
      return this.menuData.filter((item) => item.children);
    },
    isCollapse() {
      return this.$store.state.tab.isCollapse;
    },
    menuData() {
      return this.$store.state.tab.menuList;
    },
    sideValue() {
      return this.$store.state.settings.sideValue;
    },
    // Extract background color logic based on sideValue
    menuBackgroundColor() {
      return this.sideValue === 'darkColor' ? '#2b2f3a' : '#fff';
    },
    // Extract text color logic based on sideValue
    menuTextColor() {
      return this.sideValue === 'darkColor' ? '#fff' : 'rgba(0, 0, 0, 0.88)';
    },
    // Extract class for logo text style
    logoClass() {
      return this.sideValue;
    },
    // 侧边栏宽度
    sideWidth() {
      this.width = this.$store.state.settings.sideWidth + 'px';
      return this.$store.state.settings.sideWidth;
    },
  },
  mounted() {
    const storedMenuList = JSON.parse(window.sessionStorage.getItem("menuList"));
    if (storedMenuList) {
      this.$store.dispatch('updateMenuList', storedMenuList);
    }
  }
};
</script>

<style lang="scss" scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: v-bind('width');
  min-height: 400px;
}

.sidebarLogoFade-enter-active,
.sidebarLogoFade-leave-active {
  transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
}

.sidebarLogoFade-enter {
  opacity: 0;
  transform: translateY(-10px);
}

.sidebarLogoFade-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

.logo {
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.el-menu {
  height: 100vh;
  border-right: none;

  h3 {
    text-align: center;
    font-size: 16px;
    font-weight: 400;
  }
}
</style>
